module.exports = __webpack_public_path__ + "img/17_59.b5392265.png";